import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { MatSidenav } from "@angular/material/sidenav";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { DashboardService } from "src/app/services/dashboard.service";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { EmailService } from "src/app/services/email-service";
import { FilterService } from "src/app/services/filter.service";
import { GridStateService } from "src/app/services/grid-state.service";
import { IconService } from "src/app/services/icon.service";
import { NavigationService } from "src/app/services/navigation.service";
import { PhiSecurityService } from "src/app/services/phi-security.service";
import { PhiTimerService } from "src/app/services/phi-timer.service";
import { SessionService } from "src/app/services/session.service";
import { UserActivityService } from "src/app/services/useractivity.service";

@Component({
    selector: "app-user-menu",
    templateUrl: "./user-menu.component.html",
    styleUrls: ["./user-menu.component.scss"],
    standalone: false
})
export class UserMenuComponent implements OnInit {
  @Input("menuItems") menuItems: any[] = [];
  @Output() onSelect = new EventEmitter<any>();
  @Output("sidebarSize") sidebarSize = new EventEmitter<any>();

  @ViewChild("sidenav") sidenav: MatSidenav | undefined;

  clientKey: any;
  clientName: any;
  userName: string = "";
  logo: boolean = false;
  starts = "search_icon";
  modeOver = "over";
  toggleClicked = false;

  isExpanded = false;
  showSubmenu: boolean = false;
  showSubSubMenu: boolean = false;
  reqSubcription: Subscription[] = [];
  hovered: any;
  highlightedIcon: any;
  moduleKey: any;
  iconsforUserMenu: any = [];
  selectedName: any;
  isIpad = false;
  brandKeyData: any[] = [];
  test: any;
  menuState: string = "out";
  clickWaitsUntilYes = false;

  constructor(
    private iconService: IconService,
    private sessionService: SessionService,
    public dashboardService: DashboardService,
    private router: ActivatedRoute,
    private route: Router,
    private navigationService: NavigationService,
    public filterService: FilterService,
    public matIconRegistry: MatIconRegistry,
    public domSanitizer: DomSanitizer,
    private userActivityService: UserActivityService,
    public deviceDetectionService: DeviceDetectionService,
    public emailService: EmailService,
    private gridStateService: GridStateService,
    private cdr: ChangeDetectorRef,
    private phiSecurityService: PhiSecurityService
  ) {
    this.reqSubcription.push(
      this.filterService.userMenuSideBar.subscribe((res: any) => {
        if (res) this.isExpanded = true;
      })
    );
  }

  public highlightRow(emp: any, access_flg: any) {
    if (access_flg != "N") {
      this.selectedName = emp.module_key;
    }
  }

  ngOnInit(): void {
    this.userName = this.sessionService.getUsername();
    let clientObj: any;
    let client: any;

    if (sessionStorage.getItem("client")) {
      let clientData = sessionStorage.getItem("client");
      clientObj = JSON.parse(clientData as any);

      if (clientObj && clientObj.length && clientObj[0].client) {
        client = clientObj[0].client;
        this.clientKey = client.client_key;
        this.clientName = client.client_nm;
      }
    } else {
      this.route.navigate([`home/`]);
    }

    if (this.clientKey) {
      // 1. Create a unique key for this specific user and client
      // const storageKey = `modules_Scraii`;
      
      // // 2. Try to get cached data
      // const cachedModules = sessionStorage.getItem(storageKey);

      // if (cachedModules) {
      //   // If cache exists, use it immediately and skip the API call
      //   const modules = JSON.parse(cachedModules);
      //   this.saveDataInSession(modules);
      // } else {
        // 3. No cache found, proceed with the API call
        let body = {
          username: this.userName,
          client_key: this.clientKey,
        };

        this.reqSubcription.push(
          this.dashboardService.getModuleAccess(body).subscribe(
            (modules:any) => {
              // 4. Save to Local Storage for next time
              // sessionStorage.setItem(storageKey, JSON.stringify(modules));
              
              this.saveDataInSession(modules);
            },
            (err:any) => {
              console.error('Failed to fetch module access', err);
            }
          )
        );
      // }
    }
  }

  saveDataInSession(modules: any) {
    this.sessionService.setEmployeeId(modules[0].employee_key);
    this.filterService.employKey = modules[0].employee_key;

    // Inject WorkFlow Designer when the API has no row for it yet.
    modules = this.dashboardService.ensureStaticDirectModules(modules);

    this.menuItems = modules;
    this.menuItems = this.menuItems.filter(
      (item: any) => item.module_nm !== "Email" && item.module_nm !== "Calendar"
    );

    this.dashboardService.menuItems = modules;

    // queryParams are root-level, so this works regardless of route nesting depth.
    this.reqSubcription.push(
      this.router.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        let currentModuleKey = decryptedParams["md_key"];
        let activeModule = this.menuItems.find(
          (m: any) => `${m.module_key}` === `${currentModuleKey}`
        );

        if (activeModule) {
          this.highlightedIcon = activeModule.module_key;
          this.filterService.firstModuleKey = activeModule.module_key;
        } else {
          this.highlightedIcon = modules[0].module_key;
          this.filterService.firstModuleKey = modules[0].module_key;
          let flg = this.menuItems.find((res: any) => res.access_flg == "Y");
          this.onClick(flg);
        }
      })
    );
  }

  selectedMenu(menu: any) {
    if (menu.isSelected) return "icon-hover";
    return "icon-normal";
  }
  private onClickInFlight = false;
  onClick(item: any) {
    if (item.access_flg !== "Y") return false;
    if (this.onClickInFlight) return false;
    this.onClickInFlight = true;
    setTimeout(() => (this.onClickInFlight = false), 600);

    // reset the Time Cycle filter to default when we navigate to new page
    this.userActivityService.clearTimeCycleFilter();
    /////////////////////////////////////

    // Clear grid state only if changing modules
    if (item.module_key !== this.filterService.firstModuleKey) {
      this.gridStateService.clearAllGridStates();
    }

    this.filterService.clearAllWidgetStates();
    this.dashboardService.userMenuModuleHandle(true, item);
    this.cdr.detectChanges();

    this.filterService.phiChecked = false;
    sessionStorage.removeItem('phiLogged')
    this.phiSecurityService.removePHIWarningOverlay();
    this.phiSecurityService.disableRestrictions();
  }

  styleObject(menu: any) {
    return { "background-image": "url(" + menu.active_image + ")" };
  }

  handleSidebarToggle() {
    if (!this.clickWaitsUntilYes) {
      this.clickWaitsUntilYes = true;

      if (this.toggleClicked) {
        this.toggleClicked = false;
        this.isExpanded = false;
      } else {
        this.toggleClicked = true;
      }
      this.sidebarSize.next(this.toggleClicked);

      setTimeout(() => {
        this.clickWaitsUntilYes = false;
      }, 2000);
    }
  }

  mouseenter() {
    if (!this.toggleClicked) {
      this.isExpanded = true;
    }
  }

  mouseleave() {
    if (!this.toggleClicked) {
      this.isExpanded = false;
    }
    this.filterService.userMenuSideBar.next(false);
  }

  toggleMenu() {
    this.menuState = this.menuState === "out" ? "in" : "out";
  }

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
